import React, {useEffect, useState} from 'react';
import './MeasuresCard.scss';
import {t} from 'react-switch-lang';
import {format, parseISO} from 'date-fns';
import {getCourtRisk} from '../../services/getRisk';
import {courtRiskId, incurredRiskId, potentialRiskId} from "../../utils/const";

const Card = ({card}) => {

  const onCardClick = () => {
    if (card.riskTypeId === potentialRiskId) {
      window.location = `/potential-risk/${card.riskId}?tab=measures&measure=${card.id}`;
    } else if (card.riskTypeId === incurredRiskId) {
      window.location = `/incurred-risk/${card.riskId}?tab=measures&measure=${card.id}`;
    } else if (card.riskTypeId === courtRiskId) {
      getCourtRisk(card.riskId)
        .then((r) => {
          window.location = `/court-risk/${r.data[0].id}?tab=measures&measure=${card.id}`;
        })
        .catch((r) => {
          window.location = '/403';
        });
    }
  };

  return (
    <div className="document-card" onClick={() => onCardClick()}>
      <div className=" text-left">
        <div className="document-card-header">
          <p className="mb-0 text-truncate"> {card.riskTitle}</p>
        </div>
        <div className="document-card-body">
          <p className="text-truncate">
            {t('measures.riskTypeName')}:
            <span className="text-truncate blue">
              {card.riskTypeName}
            </span>
          </p>
          <p className="text-truncate">
            {t('measures.realizationDate')}:
            <span className="text-truncate">
              {format(parseISO(card.realizationDate), 'dd.MM.yyyy.')}{' '}
            </span>
          </p>

          <p className="text-truncate ">
            {t('measures.measureStatus')}:
            <span
              className={`text-truncate ${
                card.levelOfMeasureRealization === 'NOTSTARTED'
                  ? 'red'
                  : card.levelOfMeasureRealization === 'INPROGRESS'
                  ? 'green'
                  : ''
              }`}
            >
              {card.levelOfMeasureRealization === 'NOTSTARTED'
                ? t('measures.notStarted')
                : t('measures.during')}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Card;
